// ============================================================
//  Playlist Endpoints (based on OpenAPI spec)
// ============================================================

import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class PlaylistGetByOwnerRequest extends WebServiceRequest {
    constructor(context) {
        super(context)
        super.setMethod('GET')
    }
    setParams(data) {
        // data = { ownerType, ownerId }
        super.setTag(`Playlist/owner/${data.ownerType}/${data.ownerId}`)
        super.setRequestParam(data)
    }
}

class PlaylistCreateRequest extends WebServiceRequest {
    constructor(context) {
        super(context)
        super.setMethod('POST')
        super.setTag('Playlist')
    }
    setParams(data) {
        // data = { title, description, ownerType, ownerId, sortOrder }
        super.setRequestParamDataObj(data)
    }
}

class PlaylistUpdateRequest extends WebServiceRequest {
    constructor(context) {
        super(context)
        super.setMethod('PUT')
    }
    setParams(data) {
        // data = { playlistId, title, description, isActive, sortOrder }
        super.setTag(`Playlist/${data.playlistId}`)
        super.setRequestParamDataObj(data)
    }
}

class PlaylistDeleteRequest extends WebServiceRequest {
    constructor(context) {
        super(context)
        super.setMethod('DELETE')
    }
    setParams(data) {
        // data = { playlistId }
        super.setTag(`Playlist/${data.playlistId}`)
        super.setRequestParam(data)
    }
}

class PlaylistAddItemRequest extends WebServiceRequest {
    constructor(context) {
        super(context)
        super.setMethod('POST')
    }
    setParams(data) {
        // data = { playlistId, fileEntryId, sortOrder }
        super.setTag(`Playlist/${data.playlistId}/items`)
        super.setRequestParamDataObj(data)
    }
}

class PlaylistGetItemsRequest extends WebServiceRequest {
    constructor(context) {
        super(context)
        super.setMethod('GET')
    }
    setParams(data) {
        // data = { playlistId }
        super.setTag(`Playlist/${data.playlistId}/items`)
        super.setRequestParam(data)
    }
}

class PlaylistRemoveItemRequest extends WebServiceRequest {
    constructor(context) {
        super(context)
        super.setMethod('DELETE')
    }
    setParams(data) {
        // data = { playlistId, fileEntryId }
        super.setTag(`Playlist/${data.playlistId}/items/${data.fileEntryId}`)
        super.setRequestParam(data)
    }
}

class PlaylistReorderItemsRequest extends WebServiceRequest {
    constructor(context) {
        super(context)
        super.setMethod('PUT')
    }
    setParams(data) {
        // data = { playlistId, order: { fileEntryId: sortOrder, ... } }
        super.setTag(`Playlist/${data.playlistId}/items/reorder`)
        // The body is an object with fileEntryId as keys and sortOrder as values
        const orderData = { ...data }
        delete orderData.playlistId
        super.setRequestParamDataObj(orderData)
    }
}

// ============================================================
//  Exports
// ============================================================

export {
    PlaylistGetByOwnerRequest,
    PlaylistCreateRequest,
    PlaylistUpdateRequest,
    PlaylistDeleteRequest,
    PlaylistAddItemRequest,
    PlaylistGetItemsRequest,
    PlaylistRemoveItemRequest,
    PlaylistReorderItemsRequest
}
